<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        small
        color="primary"
        v-on="on"
      >
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-text class="font-weight-bold">
        {{ payrollTransactionDetail.company_employee.employee.person.name }}'s {{ payrollTransactionDetail.deduction_or_earning.name }}
      </v-card-text> 

      <v-card-text class="pt-0">
        <v-text-field
          v-model="localPayrollTransactionDetail.amount"
          v-money="money"
          label="Amount"
          data-vv-name="amount"
          data-vv-as="amount" 
          prefix="RM"
          @keydown.native="['-', 'Subtract'].includes($event.key) && $event.preventDefault()"
          @paste.native="$event.clipboardData.getData('text').includes('-') && $event.preventDefault()"
        />
      </v-card-text>

      <v-card-text
        v-if="payrollTransactionDetail.is_fixed_doe"
        class="pt-0"
      >
        <v-textarea
          v-model="payrollTransactionDetail.remark"
          v-validate="'required|max:255'"
          counter
          :error-messages="errors.collect('remark')"
          data-vv-name="remark"      
          label="Remark"
          rows="3"
          fillable
          auto-grow
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          class="white--text"
          color="hrissecondary"          
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    $_veeValidate: {
      validator: 'new',
    },
    directives: { money: VMoney },
    props: {
      payrollTransactionDetail: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
        remark: null,
        localPayrollTransactionDetail: {
          amount: 0,
        },
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },

    watch: {
      menu: function (value) {
        this.localPayrollTransactionDetail = { ...this.payrollTransactionDetail }

        if (this.localPayrollTransactionDetail.amount) { this.localPayrollTransactionDetail.amount = Math.abs(Math.round((this.localPayrollTransactionDetail.amount / 100) * 100) / 100).toFixed(2) }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 
            this.progressing = true

            this.$api.payrollTransactionDetails().update(this.payrollTransactionDetail.id, { remark: this.payrollTransactionDetail.remark, amount: this.localPayrollTransactionDetail.amount.toString().replaceAll(',', '') })
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.menu = false
                }
              })
              .catch(error => {
                if (error.response.status >= 400 && error.response.status < 500) {
                  this.$snack({ 
                    color: 'error',
                    message: error.response.data.status, 
                  })
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
    },
  }
</script>
